import _defineProperty from '@babel/runtime/helpers/defineProperty';
import '../../../../../../../util/styles/index.js';
import { mergeProps } from '@react-aria/utils';
import { useFormFieldContext } from '../../../../FormField/hooks/useFormFieldContext.js';
import { isSelected, getSelectTextColor } from '../../../helpers/Select.helpers.js';
import { useSelectContext } from '../../../hooks/useSelectContext.js';
import { DISABLED_DEFAULT_STYLES, COMMON_DEFAULT_STYLES } from '../../../../../shared/constants.js';
import { useAdsStyles } from '../../../../../../../util/styles/hooks/useAdsStyles.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSelectTrigger = function useSelectTrigger(props) {
  var pe = props.pe;
  var _useFormFieldContext = useFormFieldContext(),
    isDisabled = _useFormFieldContext.isDisabled;
  var _useSelectContext = useSelectContext(),
    triggerRef = _useSelectContext.triggerRef,
    listBoxSettings = _useSelectContext.listBoxSettings,
    triggerProps = _useSelectContext.triggerProps,
    state = _useSelectContext.state;
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var disabledStyles = _objectSpread(_objectSpread({}, DISABLED_DEFAULT_STYLES), {}, {
    backgroundColor: 'base.transparent',
    pointerEvents: 'none'
  });
  var triggerStyle = mapAdsStyles(_objectSpread(_objectSpread(_objectSpread({}, COMMON_DEFAULT_STYLES), {}, {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 'inherit',
    p: '0',
    textAlign: 'start',
    gap: '8',
    backgroundColor: 'base.surface'
  }, isDisabled && disabledStyles), pe && {
    pe: pe
  }));
  var mergedTriggerProps = mergeProps(triggerProps, triggerStyle, state !== null && state !== void 0 && state.isOpen ? {
    'data-pressed': true
  } : {});
  var isPlaceholder = !isSelected(listBoxSettings === null || listBoxSettings === void 0 ? void 0 : listBoxSettings.selectedKeys);
  var contentStyle = mapAdsStyles({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    width: '100%',
    gap: '8',
    minHeight: '20px',
    textColor: getSelectTextColor(isPlaceholder, isDisabled),
    fontStyle: isPlaceholder ? 'italic' : 'normal',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: '0'
  });
  var iconContainerStyle = mapAdsStyles({
    display: 'flex',
    backgroundColor: isDisabled ? 'base.transparent' : 'base.surface',
    flexShrink: 0,
    flexGrow: 0
  });
  return {
    isDisabled: isDisabled,
    triggerRef: triggerRef,
    triggerProps: mergedTriggerProps,
    contentProps: contentStyle,
    iconContainerProps: iconContainerStyle
  };
};

export { useSelectTrigger };
//# sourceMappingURL=useSelectTrigger.js.map
